import styled, { css } from 'styled-components';
import Image from '@components/image';
import LinkComponent from '@components/link';
import Text from '@components/text';
import { headerHeight } from '@components/header/header.styled';

export const SmallCopy = styled.div`
  ${({ theme }) => css`
    max-width: 30rem;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: 0 ${theme.spacing.md};
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 0 ${theme.spacing.sm};
    }
  `}
`;

export const TextContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    z-index: ${theme.zIndex.layeredContent};
    margin: ${theme.spacing.xl} 0;
    align-self: flex-start;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      max-width: 40rem;
    }
  `}
`;

export const ImageContainer = styled.div`
  ${({ theme }) => css`
    z-index: ${theme.zIndex.layeredGraphic};
    position: absolute;
    top: 5rem;
    width: calc(50vw + 0rem);
    left: calc(50% + 2rem);
    height: calc(100% - 5rem);
    border-top-left-radius: ${theme.borderRadius.large};
    overflow: hidden;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      left: calc(50% + 1.5rem);
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: calc(100% + ((100vw - 100%) / 2));
      position: relative;
      top: unset;
      left: unset;
      height: 16rem;
    }

    > div {
      width: 100%;
      height: 100%;
    }
  `}
`;

interface StyledImageProps {
  imageFit?: boolean;
}

export const StyledImage = styled(Image)<StyledImageProps>`
  ${({ theme, imageFit }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
      object-position: 50% 50%;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      img {
        object-position: ${imageFit ? '50% 50%' : '0% 50%'} !important;
      }
    }
  `}
`;

export const Header = styled.header`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.backgroundColors.dark};
    padding-top: ${headerHeight};

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding-top: 4rem;
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
      row-gap: 0rem;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)`
  ${({ theme }) => css`
    border: 1.5px solid ${theme.colors.primary};
    background-color: transparent;
    color: ${theme.colors.white};
    font-size: 1.0625rem;
    transition: transform 0.125s ease-in-out;

    svg {
      fill: ${theme.colors.secondary};
      stroke: ${theme.colors.secondary};
    }

    &:hover {
      background-color: ${theme.colors.primary};
      color: ${theme.colors.secondary};
      transform: scale(1.05);

      svg {
        fill: ${theme.colors.secondary};
        stroke: ${theme.colors.secondary};
      }
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 3.5rem;
    position: relative;
    width: calc(50% - 2rem);
    justify-content: space-between;
    padding: 5rem 0;
    margin: 0rem 0;
    min-height: 26rem;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: 4.5rem 0;
      row-gap: 3.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 4rem 0;
      row-gap: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 3rem 0;
      row-gap: 2rem;
      width: 100%;
      min-height: unset;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 3rem 0;
      row-gap: 1.5rem;
    }
  `}
`;

export const StyledSubheading = styled(Text)`
  ${({ theme }) => css`
    padding-left: 0.9375rem;
    border-left: 0.25rem solid ${theme.colors.primary};
    max-width: 30rem;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding-left: 0.75rem;
  `}
`;
